import styled from 'styled-components'
import { UngatedProductCard } from '@/features/shop/components/UngatedCategoryPage/UngatedProductCard'
import { Fragment } from 'react'
import { type InfiniteData } from '@tanstack/react-query'
import { type SearchResults } from '@/features/shop/services/Search/types'
import { screenSizes } from '@shipt/design-system-themes'

type Props = {
  data: InfiniteData<Pick<SearchResults, 'products'>> | undefined
}

export const UngatedInfiniteProductGrid = ({ data }: Props) => {
  return (
    <GridUL>
      {data?.pages.map((page, i) => (
        <Fragment key={page.products?.[i]?.id}>
          {page.products?.map((product, idx) => (
            <UngatedProductCard product={product} key={product.id} index={idx} />
          ))}
        </Fragment>
      ))}
    </GridUL>
  )
}

const GridUL = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, 162px);
  justify-content: space-between;
  list-style-type: none;
  gap: 30px 16px;
  margin: 0;
  padding: 0;

  @media ${screenSizes.max_mobile} {
    column-gap: 0;
  }
`

export const UngatedProductGrid = ({
  data,
}: {
  data: Pick<SearchResults, 'products'>['products']
}) => {
  return (
    <GridUL data-cy="ungated-product-grid">
      {data?.map((product, i) => (
        <UngatedProductCard product={product} key={product.id} index={i} />
      ))}
    </GridUL>
  )
}
